var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.drs.daily_return_sheets_images),function(image,index){return _c('div',{key:index,staticClass:"page-break"},[_c('img',{staticClass:"mr-5",attrs:{"src":image}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }